module.exports = __webpack_public_path__ + "img/fitt_logo.cc764b57.svg";